import type { ColorValue, Platform } from 'react-native';
import type { ThemeMode } from '@/stores/useThemeStore';

const IOS_MODAL_BACKGROUND = '#000000';

const backgroundColorByTheme = {
  dark: '#000000',
  light: '#F1F1F1',
} satisfies Record<ThemeMode, ColorValue>;

export function getAppBackgroundColor(
  theme: ThemeMode,
  platform: typeof Platform.OS,
): ColorValue {
  return platform === 'ios'
    ? IOS_MODAL_BACKGROUND
    : backgroundColorByTheme[theme];
}
